<script>
import { CountTo } from "vue3-count-to";

import {
  UsersIcon,
} from "@zhuowenli/vue-feather-icons";

export default {
  props:['agentsList', 'stateSelected'],
  components: {
    CountTo,
    UsersIcon
  },
  methods: {
  },
  computed: {
    firstRow() {
      const half = Math.floor(this.agentsList.length / 2);
      return this.agentsList.slice(0, half);
    },
    secondRow() {
      const half = Math.floor(this.agentsList.length / 2);
      return this.agentsList.slice(half);
    }
  }
};
</script>
<style>

</style>
<template>
  <div class="container-fluid px-2">
    <h2 class="my-3 text-center text-md-start">Agents</h2>

    <!-- Row 1 -->
    <div class="row g-3">
      <div
          class="col-6 col-md-4 col-xl"
          v-for="(item, index) in firstRow"
          :key="'row1-' + index"
      >
        <router-link
            :to="'/agents/List?n=' + item.name + '&state=' + stateSelected"
            class="text-decoration-none"
        >
          <div class="card h-100 shadow-sm card-animate" @click="checkStateSelected()">
            <div class="card-body border border-2 rounded-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="fw-medium mb-1" :style="{ color: item.color }">{{ item.name }}</p>
                  <h2 class="ff-secondary fw-semibold mb-0">
                    <count-to :startVal="0" :endVal="item.total" :duration="3000" />
                  </h2>
                </div>
                <div>
                  <div class="avatar-sm bg-primary rounded-circle d-none d-sm-flex align-items-center justify-content-center">
                    <users-icon style="color: white;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <!-- Row 2 -->
    <div class="row g-3 mt-1">
      <div
          class="col-6 col-md-4 col-xl"
          v-for="(item, index) in secondRow"
          :key="'row2-' + index"
      >
        <router-link
            :to="'/agents/List?n=' + item.name + '&state=' + stateSelected"
            class="text-decoration-none"
        >
          <div class="card h-100 shadow-sm card-animate" @click="checkStateSelected()">
            <div class="card-body border border-2 rounded-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="fw-medium mb-1" :style="{ color: item.color }">{{ item.name }}</p>
                  <h2 class="ff-secondary fw-semibold mb-0">
                    <count-to :startVal="0" :endVal="item.total" :duration="3000" />
                  </h2>
                </div>
                <div>
                  <div class="avatar-sm bg-primary rounded-circle d-none d-sm-flex align-items-center justify-content-center">
                    <users-icon style="color: white;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
  &nbsp;
  &nbsp;
</template>


